export const REFERRAL_REDEEM_CODE_PATH = "referral/redeem";
export const REFERRAL_REDEEM_CODE_FULL_PATH = `/home-v2/${REFERRAL_REDEEM_CODE_PATH}`;
